import {storageUtil} from '@px/helper/storage';

interface StrategyGridStorage extends StorageObject {
  positionGridPreview: boolean;
}

const STORAGE_KEY = 'strategy_grid';

export const StrategyGridStorage = {
  read(): StrategyGridStorage {
    return storageUtil.readStorageObject(STORAGE_KEY, createInitSpotStorage());
  },
  update(kv: Record<string, any>) {
    storageUtil.writeStorageObject(STORAGE_KEY, {...StrategyGridStorage.read(), ...kv});
  },
};

function createInitSpotStorage(): StrategyGridStorage {
  return {
    version: 1,
    positionGridPreview: false,
  };
}
